<template>
  <div>
    <v-btn color="primary" @click="dialog = false">Mostrar Kardex Bonos</v-btn>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Kardex Bonos</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fechaInicio"
                  label="Fecha Inicio"
                  type="date"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fechaFin"
                  label="Fecha Fin"
                  type="date"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-btn color="primary" @click="fetchKardexBonos">Buscar</v-btn>

          <v-data-table
            v-if="kardexBonos.length"
            :headers="headers"
            :items="kardexBonos"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.fecha="{ item }">
              {{ new Date(item.fecha).toLocaleDateString() }}
            </template>
          </v-data-table>

          <v-alert v-if="!kardexBonos.length && dataFetched" type="info" class="mt-3">
            No hay datos disponibles.
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    cliente: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      fechaInicio: '',
      fechaFin: '',
      kardexBonos: [],
      dataFetched: false,
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Factura', value: 'factura' },
        { text: 'Importe', value: 'importe' },
        { text: 'Saldo', value: 'saldo' },
        { text: 'Origen', value: 'origen' },
        { text: 'Cliente', value: 'cliente' },
      ],
    };
  },
  methods: {
    async fetchKardexBonos() {
      if (this.fechaInicio && this.fechaFin) {
        try {
          const response = await fetch(
            `api/Reportes/ListarKardexBonos/${this.cliente}/${this.fechaInicio}/${this.fechaFin}`
          );
          if (!response.ok) {
            throw new Error('Error al obtener los datos');
          }
          this.kardexBonos = await response.json();
          this.dataFetched = true;
        } catch (error) {
          console.error(error);
          this.kardexBonos = [];
          this.dataFetched = true;
        }
      } else {
        alert('Por favor seleccione ambas fechas.');
      }
    },
  },
};
</script>

<style scoped>
/* Agrega estilos personalizados aquí */
</style>